import React from "react";
import { Link } from "react-router-dom";

export default function SecurityNotice() {
  return (
    <section
      className="rounded-2xl border border-black/5 dark:border-white/10
                 bg-white dark:bg-slate-900 shadow-sm p-5"
    >
      <div className="rounded-2xl bg-slate-50 dark:bg-white/5 border border-black/5 dark:border-white/10 p-4">
        <h2 className="text-base font-semibold text-slate-900 dark:text-white">
          Votre argent est protégé avec nous
        </h2>
        <p className="mt-2 text-sm text-slate-600 dark:text-slate-300 leading-relaxed">
          Nous protégeons vos transferts grâce à des contrôles de sécurité, une technologie fiable
          et un support disponible 24/7.
          <Link to="/about-us" className="ml-1 text-blue-600 dark:text-blue-400 font-medium hover:underline">
            En savoir plus
          </Link>
        </p>
      </div>
    </section>
  );
}
